module.exports = __webpack_public_path__ + "img/menu_bfbt.2c320967.png";